import React from 'react';
import PropTypes from 'prop-types';
import cnames from 'classnames';
import _styles from './styles.module.css';

const CardHeader = ({ children, padded, styles, parentStyles }: any) => (
  <div
    className={cnames(
      styles.header,
      parentStyles.cardHeader,
      {
        [styles.padded]: padded,
      },
    )}
  >
    { children }
  </div>
);

(CardHeader as any).propTypes = {
  children: PropTypes.node.isRequired,
  padded: PropTypes.bool,
  styles: PropTypes.shape({}),
  parentStyles: PropTypes.shape({}),
};

(CardHeader as any).defaultProps = {
  padded: true,
  styles: _styles,
  parentStyles: undefined,
};

(CardHeader as any).displayName = 'CardHeader';

export default CardHeader;
